// headerHeight = 38 + $('header').height();
headerHeight = 0;
promoHeight = $('#shopify-section-top-bar').height();
var totalHeight = (headerHeight + promoHeight) + 'px';
  $('#NavDrawer').css('top', totalHeight);
$('.mobile-menu-icon').click(function(){
  if($('#spinner-form').is(':checked')){
    $('#NavDrawer').addClass('opened');
    $('#shopify-section-top-bar').css('position','fixed').css('z-index', '4');
    $('.header-content').css('padding-top', '39px');
    $('.mobile-branch-left, .mobile-branch-right').css('top', 'calc(55% + 18px)');
  } else {
    $('#NavDrawer').removeClass('opened');
    $('#shopify-section-top-bar').css('position','').css('z-index','');
    $('.header-content').css('padding-top', '');
    $('.mobile-branch-left, .mobile-branch-right').css('top', '');
  }
});

$(document).ready(function(){
  // Search
  $('.search').click(function(){
    $('.search-dropdown').fadeIn('fast').addClass('search-visible');
    $('.search-backdrop').fadeIn('fast');
  });
  $(document).on('click', function(event){
    if ((event.target.className == 'search-dropdown' || event.target.className == 'search-input' || event.target.className == 'search-text' || event.target.className == 'search-box' || event.target.className == 'search-visible'  || event.target.className == 'search') ) {
    } else {
      $('.search-dropdown').fadeOut('fast');
      $('.search-backdrop').fadeOut('fast');
    }
  });

  // $('.tab-section').delay(100).css('height', $('.section').outerHeight());
  // $('.tab-listing li').first().addClass('active');
  // $('.tab-listing li').click(function(){
  //   $(this).addClass('active').siblings().removeClass('active');
  //   var active_tab = ".tab-" + $(this).attr('id');
  //   $('.tab-section').css('height', $(active_tab).outerHeight());
  //   $('.tab-section > div').fadeOut();
  //   $(active_tab).delay(200).fadeIn();
  // });

  // $('.section h5').click(function(){
  //   $(this).addClass('active').siblings('h5').removeClass('active');
  //   var active_tab = ".tab-" + $(this).text().toLowerCase();
  //   $('.section > div').slideUp();
  //   $(active_tab).slideDown();
  // });
  // $(window).resize(function(){
  //   var active_tab = ".tab-" + $('.tab-listing li.active').attr('id');
  //   $('.tab-section').css('height', $(active_tab).outerHeight());
  // });
  $('.product-slider').slick({
    'dots': false,
    'arrows': true,
    'prevArrow': '<button type="button" class="slick-prev"><i class="fa fa-chevron-left"></i></button>',
    'nextArrow': '<button type="button" class="slick-next"><i class="fa fa-chevron-right"></i></button>',
    'adaptiveHeight': true
  });
});

$(document).ready(function(){
  $('.magic-slideshow').slick({
    'dots': false,
    'arrows': true,
    'prevArrow': '<button type="button" class="slick-prev"><img src="//bamboletta.com/cdn/shop/t/21/assets/slideshow-left.png?v=176781946146086034741769129147" alt="" /></button>',
    'nextArrow': '<button type="button" class="slick-next"><img src="//bamboletta.com/cdn/shop/t/21/assets/slideshow-right.png?v=108313671256280432541769129147" alt="" /></button>',
    'adaptiveHeight': true
  });
  $('ul.tab-listing li:nth-child(1)').click(function(){
    $('.magic-slideshow').slick('slickGoTo', 0);
  });
  $('ul.tab-listing li:nth-child(2)').click(function(){
    $('.magic-slideshow').slick('slickGoTo', 1);
  });
  $('ul.tab-listing li:nth-child(3)').click(function(){
    $('.magic-slideshow').slick('slickGoTo', 2);
  });
  $('ul.tab-listing li').first().addClass('active');
  $('.magic-slideshow').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    $('ul.tab-listing li').each(function(){
      $(this).removeClass('active');
    });
  });
  $('.magic-slideshow').on('afterChange', function(event, slick, currentSlide, nextSlide){
    var tabid = ".section[data-slick-index='" + currentSlide + "']";
    var active_tab = "#" + $(tabid).data('id');
    $('ul.tab-listing li').each(function(){
      if($(this).is(active_tab)){
        $(this).addClass('active');
      } else {
        $(this).removeClass('active');
      }
    });
  });
});
